<h2>Log for {{opCoSelected}}</h2>
<div class="log-query">
  <h5><app-euds-svg icon="feather/search" size="md"></app-euds-svg>Query</h5>
  <div class="log-controls">
    <app-euds-textfilter label="Query Term"
                         class="log-search-input"
                         placeholder="Enter query term"
                         [showResultMessage]="false"
                         [(ngModel)]="searchTerm"
                         (enterEvent)="applySearch()">
    </app-euds-textfilter>
    <div class="log-button-bar">
      <app-euds-button type="primary"
                       label="Apply"
                       class="log-apply-button"
                       [disabled]="isLoading"
                       (clickEvent)="applySearch()">
      </app-euds-button>
      <app-euds-button type="secondary"
                       label="Clear"
                       (clickEvent)="clearSearch()"></app-euds-button>
    </div>
  </div>
</div>

<app-euds-textfilter class="margin-top-2"
                     label="Search"
                     [hideLabel]="true"
                     placeholder="Search Log Results..."
                     [resultCount]="filterCount"
                     [showResultMessage]="true"
                     (valueChange)="filterDataSource($event)"
                     (blurEvent)="filterDataSource($event)"
                     (clearEvent)="resetDataSource($event)"
                     (enterEvent)="filterDataSource($event)">
</app-euds-textfilter>

<div *ngIf="isLoading" class="loading-container" role="status" aria-live="polite">
  <p>Loading logs...</p>
</div>

<app-euds-alert *ngIf="error && !isLoading"
                class="margin-top-4 margin-bottom-4"
                type="error"
                [primaryText]="error">
</app-euds-alert>

<app-euds-data-table #tableLogs class="margin-top-4"
                     *ngIf="!isLoading && !error && displayedLogData?.length > 0"
                     [showCaption]="false"
                     caption="Application Logs Table"
                     [condensed]="false"
                     [striped]="true"
                     [dataSource]="displayedLogData"
                     [columnDefs]="columnDefsLog"
                     (sortFunction)="sortTableData($event)">
  <ng-container *ngFor="let logEntry of displayedLogData; index as idx">
    <tr app-euds-table-row [index]="idx">
      <td app-euds-table-cell>{{logEntry.timestamp | date:'short'}}</td>
      <td app-euds-table-cell [innerHtml]="logEntry.itemType | highlight: searchText">{{logEntry.itemType}}</td>
      <td app-euds-table-cell [innerHtml]="logEntry.combinedMessage | highlight: searchText">{{logEntry.combinedMessage}}</td>
      <td app-euds-table-cell [innerHtml]="logEntry.cloud_RoleName | highlight: searchText">{{logEntry.cloud_RoleName}}</td>
    </tr>
  </ng-container>
</app-euds-data-table>

<p *ngIf="!isLoading && !error && displayedLogData?.length === 0">No log records found matching the criteria.</p>

<app-euds-pagination #paginationLogs
                     *ngIf="!isLoading && !error && totalLogs > itemsPerPage"
                     [itemsPerPageOptions]="itemsPerPageOptions"
                     [itemsPerPage]="itemsPerPage"
                     [totalItems]="totalLogs"
                     [currentPage]="currentPage"
                     (changeItemsPerPage)="onChangeItemsPerPage($event)"
                     (changePage)="onChangePage($event)">
</app-euds-pagination>
<app-euds-loader [visible]="isLoading"></app-euds-loader>
